import React, { ReactNode } from 'react'
import { Box, Button as MuiButton, Theme, useTheme } from '@mui/material'

interface IButtonProps {
  children?: ReactNode
  endIcon?: JSX.Element
  disabled?: boolean
  variant?: 'contained' | 'text' | 'outlined'
  size?: 'small' | 'medium' | 'large'
  type?: 'button' | 'submit' | 'reset'
  fullWidth?: boolean
  onClick?: (event: React.SyntheticEvent<Element, Event>) => void
}

const defaultSettings: IButtonProps = {
  disabled: false,
  size: 'medium',
  type: 'button',
}

const Button: React.FC<IButtonProps> = (props) => {
  const theme: Theme = useTheme()
  return (
    <Box sx={{ marginTop: theme.spacing(3), marginBottom: theme.spacing(3) }}>
      <MuiButton
        endIcon={props.endIcon || <></>}
        sx={{
          backgroundColor: theme.palette.primary.main,
          color: '#373e59',
        }}
        fullWidth={props.fullWidth || false}
        type={props.type ?? defaultSettings.type}
        size={props.size ?? defaultSettings.size}
        variant={props.variant ?? 'outlined'}
        disabled={props.disabled ?? defaultSettings.disabled}
        onClick={(event) => props.onClick && props.onClick(event)}
      >
        {props.children}
      </MuiButton>
    </Box>
  )
}
export default Button
